import Footer from '@components/common/footer'
import Navbar from '@components/common/navbar'
import Activities from '@components/course-landing-page/activities'
import CourseDescription from '@components/course-landing-page/course-description'
import CourseModule from '@components/course-landing-page/course-module'
import FirstFold from '@components/course-landing-page/first-fold'
import FooterBanner from '@components/course-landing-page/footer-banner'
import SkillsYouWillGain from '@components/course-landing-page/skills-you-will-gain'
import StemAccredited from '@components/course-landing-page/stem-accredited'
import TestimonialsFold from '@components/course-landing-page/testimonial'
import useStoreUTMParams from '@hooks/useStoreUTMParam'
import { COURSE_NAMES } from '@lib/data/course-landing-page'
import { HPECodewarsHackathonCourse } from '@lib/seo'
import { CourseJsonLd, NextSeo } from 'next-seo'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

const CourseCard = dynamic(() =>
  import('@components/course-landing-page/course-card')
)

const { HPE_CODEWARS_HACKATHON } = COURSE_NAMES

const HPECodewarsHackathon = () => {
  const [shouldUpdateCourseCard, setShouldUpdateCourseCard] = useState(false)

  useEffect(() => {
    const handleScroll = () => setShouldUpdateCourseCard(window.scrollY > 350)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useStoreUTMParams()

  return (
    <>
      <NextSeo {...HPECodewarsHackathonCourse} />
      <CourseJsonLd
        courseName="Hpe CodeWars Hackathon Course"
        description="Learn to ace the coding Hackathon with the custom course taught by our expert instructors"
        provider={{
          '@type': 'Organization',
          name: 'Codingal',
        }}
        offers={{
          '@type': 'Offer',
          category: 'Paid',
        }}
        hasCourseInstance={{
          '@type': 'CourseInstance',
          courseMode: 'Online',
          courseWorkload: 'PT12H',
        }}
      />
      <Navbar tryFreeClassLink="/register/?course=hpe-hackathon-micro-course" />
      <FirstFold
        shouldHideCourseCard={shouldUpdateCourseCard}
        courseName={HPE_CODEWARS_HACKATHON}
        courseContentText="2 detailed modules"
        ishideStarRating
        ishideDownloadCurriculum
        bgImageUrl="/images/courses/bg2.jpg"
        isHpePage
        customPoints="Project building guidance"
        urlQuery="?course=hpe-hackathon-micro-course"
      />
      <div className="container flex justify-between pt-10 mx-auto px-5 lg:px-10 text-grey">
        <div className="pb-10 md:w-4/5 md:pr-4 max-w-3xl">
          <CourseDescription courseName={HPE_CODEWARS_HACKATHON} hideReadMore />
          <CourseModule
            courseName={HPE_CODEWARS_HACKATHON}
            heading="What will you learn in this course"
            subHeading="12 hours of live session, 2 detailed modules, quizzes & activities"
          />
          <SkillsYouWillGain
            courseName={HPE_CODEWARS_HACKATHON}
            urlQuery="?course=hpe-hackathon-micro-course"
          />
          <Activities courseName={HPE_CODEWARS_HACKATHON} />
          <StemAccredited
            heading="STEM.org Accredited Educational Experience"
            urlQuery="?course=hpe-hackathon-micro-course"
          />
          <TestimonialsFold
            courseName={HPE_CODEWARS_HACKATHON}
            heading="Hear what our students and parents have to say"
            urlQuery="?course=hpe-hackathon-micro-course"
          />
        </div>
        <div className="hidden ml-4 md:block w-80">
          <div className="pb-5 sticky top-0 pt-5 z-40 w-80">
            {shouldUpdateCourseCard && (
              <CourseCard
                shouldHideCardImage={true}
                courseName={HPE_CODEWARS_HACKATHON}
                ishideStarRating
                ishideDownloadCurriculum
                isHpePage
                customPoints="Project building guidance"
                urlQuery="?course=hpe-hackathon-micro-course"
              />
            )}
          </div>
        </div>
      </div>
      <FooterBanner
        title="Ace coding Hackathon with the custom course"
        imagePath="/images/courses/ads-banner/ads-banner-1"
        mobileImagerPath="/images/courses/ads-banner/ads-banner-1-mobile"
        url="/register/?course=hpe-hackathon-micro-course"
      />
      <Footer />
    </>
  )
}
// TODO: Remove once getInitialProps is removed from _app.tsx
export const getStaticProps = async () => {
  return {
    props: {},
  }
}

export default HPECodewarsHackathon
